/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare function datetime_timestamp_seconds(timestamp as dword) as float            
declare function datetime_timestamp_mins(timestamp as dword) as dword
declare function datetime_mins_to_timestamp(mins as word) as dword
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
function datetime_timestamp_seconds(timestamp as dword) as float
    datetime_timestamp_seconds=datetime_timestamp_mins(timestamp) * 60 + (timestamp MOD 60)
end function

function datetime_timestamp_mins(timestamp as dword) as dword
    dim days as word = 0
    dim mins as word = 0
    dim secs as byte = 0
    dim mins_offset as integer=0
    td_get_tzone_offset(APP_TIMEZONE,mins_offset)
    datetime_from_timestamp(timestamp + mins_offset * 60, days, mins, secs)
    datetime_timestamp_mins=mins
end function

function datetime_mins_to_timestamp(mins as word) as dword
    dim datetime_days,datetime_minutes as word
    dim datetime_secs as byte
    dim timestamp as dword=datetime_current_timestamp()
    datetime_from_timestamp(timestamp,datetime_days,datetime_minutes,datetime_secs)
    datetime_minutes=mins
    td_local_to_gmt(datetime_days,datetime_minutes,APP_TIMEZONE,PL_OFF)
    datetime_mins_to_timestamp=datetime_to_timestamp(datetime_days,datetime_minutes,0)
end function
`,
    });

    return blocks;
};
